import DetailTemplatePenunjangProduksi from './DetailTemplatePenunjangProduksi';

export default DetailTemplatePenunjangProduksi;
